import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'platform-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div
            class="banner-container"
            [ngStyle]="{
                background: appliedStyle.backgroundColor,
                borderColor: appliedStyle.borderColor,
                borderWidth: 1,
                borderStyle: 'solid',
            }"
        >
            <div class="icon-container">
                <i [class]="icon" [ngStyle]="{ color: appliedStyle.iconColor }"></i>
            </div>
            <div class="text-content">
                <div class="banner-title" [ngStyle]="{ color: appliedStyle.titleColor }">{{ title }}</div>
                <div class="banner-description" [ngStyle]="{ color: appliedStyle.descriptionColor }">
                    {{ description }}
                    @if (currentCount > 0) {
                        {{ taskSummaryText }}
                        {{ additionalText }}
                    }
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .banner-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0.625rem;
                gap: 20px;
                border-radius: 0.625rem;
                height: 238px;
                font-family: 'IBM Plex Sans', sans-serif;
                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
            }

            .icon-container {
                font-size: 3rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .text-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                justify-content: center;
            }

            .banner-title {
                font-size: 1.75rem;
                font-weight: 600;
                text-align: center;
            }

            .banner-description {
                font-size: 1rem;
                font-weight: 400;
            }
        `,
    ],
})
export class BannerComponent {
    @Input() icon: string = 'pi pi-exclamation-triangle'; // Default icon
    @Input() title: string = 'Reassignment Incomplete!';
    @Input() description: string = 'Task allocation was partially completed:';
    @Input() currentCount: number = 35;
    @Input() totalCount: number = 40;
    @Input() additionalText: string = 'Please verify the remaining tasks.';
    @Input() taskSummaryText: string = '';
    @Input() appliedStyle: StyleObject = {
        iconColor: '#f57c00',
        backgroundColor: '#F3F7FD',
        borderColor: '#dde7f6',
        titleColor: '#425B80',
        descriptionColor: '#425B80',
    };
}

interface StyleObject {
    iconColor: string;
    backgroundColor: string;
    titleColor: string;
    borderColor: string;
    descriptionColor: string;
}
